import AvgOfFacingsByRetailer from "./AvgOfFacingsByRetailer";
export default AvgOfFacingsByRetailer;
